var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom"},[_c('p',[_vm._v(_vm._s(_vm.msg1))]),_c('p',[_vm._v(_vm._s(_vm.msg2)+" "+_vm._s(_vm.msg3))]),_c('p',[_vm._v(_vm._s(_vm.msg4))])])}
var staticRenderFns = []

export { render, staticRenderFns }